import { type Day, getDay, nextDay, startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

/**
 * The next calendar date (today included) that falls on `dayIndex` (0 = Sunday …
 * 6 = Saturday), evaluated in `timeZone` so a recurring slot resolves to the
 * venue's "today", not the browser's. The returned Date is local midnight of that
 * calendar day — format it with `MMM d`, never read its time.
 */
export const getNextWeekdayDate = (dayIndex: number, timeZone?: string | null): Date => {
  const now = new Date();
  const today = startOfDay(timeZone ? toZonedTime(now, timeZone) : now);
  return getDay(today) === dayIndex ? today : nextDay(today, dayIndex as Day);
};
